import { CREATE_STYLE_STATUS_REPORT_SUCCESS, CREATE_STYLE_WISE_REPORT_BY_MOVE_TO_CUTTING_FAILURE, CREATE_USER_FORM_STYLE_WISE_REPORT, FETCH_COMPACTING_STATUS_REPORTS_DATA_FAILURE, FETCH_COMPACTING_STATUS_REPORTS_DATA_REQUEST, FETCH_COMPACTING_STATUS_REPORTS_DATA_SUCCESS, FETCH_COMPACTING_STATUS_REPORTS_EDIT_DATA, FETCH_COMPACTING_STATUS_REPORTS_EDIT_DATE_WISE, FETCH_STYLE_STATUS_REPORTS_DATA_FAILURE, FETCH_STYLE_STATUS_REPORTS_DATA_REQUEST, FETCH_STYLE_STATUS_REPORTS_DATA_SUCCESS, FETCH_STYLE_WISE_REPORTS_DATA_FAILURE, FETCH_STYLE_WISE_REPORTS_DATA_REQUEST, FETCH_STYLE_WISE_REPORTS_DATA_SUCCESS, FETCH_STYLE_WISE_REPORTS_DETAILS_DATA_SUCCESS, FETCH_STYLE_WISE_REPORTS_STYLE_WISE_SUCCESS, FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_FAILURE, FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_REQUEST, FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_SUCCESS, FETCH_STYLE_WISE_REPORT_WITH_COLOUR_FAILURE, FETCH_STYLE_WISE_REPORT_WITH_COLOUR_SUCCESS, FETCH_STYLE_WISE_REPORT_WITH_CUD_COLOUR_FAILURE, FETCH_STYLE_WISE_REPORT_WITH_CUD_COLOUR_SUCCESS, POST_COMPACTING_STATUS_REPORTS_DATA_FAILURE, POST_COMPACTING_STATUS_REPORTS_DATA_REQUEST, POST_COMPACTING_STATUS_REPORTS_DATE_WISE_FAILURE, POST_COMPACTING_STATUS_REPORTS_DATE_WISE_REQUEST, POST_COMPACTING_STATUS_REPORTS_DATE_WISE_SUCCESS, SET_SUMMARY_GRID_NAME_STYLE_WISE_REPORT_DK } from "./styleWiseReport.actionsType";


export const STYLE_WISE_REPORT = 'stylereports';

let initialState = {
    loading: false,
    styleReportData: [],
    styleMasterMainList: [],
    stylewiseByStyleId: [],
    styleWiseUserform: {
        fldFKUnitId: '',
        fldFKSubStyle: '',
        fldSubStyle: '',
    },
    stylewiseWithColour: [],
    stylewiseCUDWithColour: [],
    renderGridBtn: 'summaryGrid',

};

export let styleWiseReportsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_STYLE_WISE_REPORTS_DATA_REQUEST:
        case FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_REQUEST:
        case FETCH_STYLE_STATUS_REPORTS_DATA_REQUEST:
        case FETCH_COMPACTING_STATUS_REPORTS_DATA_REQUEST:
        case POST_COMPACTING_STATUS_REPORTS_DATA_REQUEST:
        case POST_COMPACTING_STATUS_REPORTS_DATE_WISE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_STYLE_WISE_REPORTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                styleReportData: updatePayload
            };
        case FETCH_STYLE_STATUS_REPORTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                styleStatusReports: updatePayload
            }
        case FETCH_STYLE_STATUS_REPORTS_DATA_FAILURE:
            return {
                ...state,
                loading: false,
                styleStatusReports: []
            }

        case FETCH_COMPACTING_STATUS_REPORTS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingStatusReports: updatePayload,
            }

        case FETCH_COMPACTING_STATUS_REPORTS_EDIT_DATA:
            return {
                ...state,
                loading: false,
                compactingStatusReports: payload
            }


        // we have 2 api have common state compactingStatusReportsDateWise to filtering data
        case POST_COMPACTING_STATUS_REPORTS_DATE_WISE_SUCCESS:
            return {
                ...state,
                loading: false,
                compactingStatusReportsDateWise: updatePayload
            }
        case FETCH_COMPACTING_STATUS_REPORTS_EDIT_DATE_WISE:
            return {
                ...state,
                loading: false,
                compactingStatusReportsDateWise: payload
            }
        case CREATE_STYLE_STATUS_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                styleStatusReportform: payload
            }

        case FETCH_STYLE_WISE_REPORTS_DETAILS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                styleReportDataSummary: updatePayload
            }
        case FETCH_STYLE_WISE_REPORTS_STYLE_WISE_SUCCESS:
            return {
                ...state,
                loading: false,
                styleMasterMainList: updatePayload
            };
        case FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                stylewiseByStyleId: updatePayload
            };
        case FETCH_STYLE_WISE_REPORT_WITH_COLOUR_SUCCESS:
            return {
                ...state,
                loading: false,
                stylewiseWithColour: updatePayload
            }
        case FETCH_STYLE_WISE_REPORT_WITH_CUD_COLOUR_SUCCESS:
            return {
                ...state,
                loading: false,
                stylewiseCUDWithColour: updatePayload
            }
        case FETCH_STYLE_WISE_REPORTS_DATA_FAILURE:
        case FETCH_STYLE_WISE_REPORT_BY_STYLE_ID_FAILURE:
        case FETCH_STYLE_WISE_REPORT_WITH_COLOUR_FAILURE:
        case FETCH_STYLE_WISE_REPORT_WITH_CUD_COLOUR_FAILURE:
        case CREATE_STYLE_WISE_REPORT_BY_MOVE_TO_CUTTING_FAILURE:
        case FETCH_COMPACTING_STATUS_REPORTS_DATA_FAILURE:
        case POST_COMPACTING_STATUS_REPORTS_DATA_FAILURE:
        case POST_COMPACTING_STATUS_REPORTS_DATE_WISE_FAILURE:

            return {
                ...state,
                loading: false
            };
        case SET_SUMMARY_GRID_NAME_STYLE_WISE_REPORT_DK:
            return {
                ...state,
                renderGridBtn: payload
            };

        case CREATE_USER_FORM_STYLE_WISE_REPORT:
            return {
                ...state,
                loading: false,
                styleWiseUserform: {
                    ...state.styleWiseUserform,
                    [payload.key]: payload.value
                }
            }

        default:
            return state;
    }
};